import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import ReactSelect from "react-select";
import ErrorMessage from './ErrorMessage';

const BusinessModelSelect = ({ name, options, defaultValue, ...props }) => {
  // convert options from {a:1} to [{label=a,value=1}]
  const { control} = useFormContext()

  const optionsComputed = [];
  // convert options[{}, ...] to [{label=a,value=1}, ...]
  for (const opt of options) {
    optionsComputed.push({label: opt.name, id: opt.id})
  };

  let defaultValueComputed = [];
  // convert defaultValue from [1] to [{label=a,value=1}]
  if (defaultValue) {
    for (const value of defaultValue)
      defaultValueComputed.push(
        optionsComputed.find(option => String(option.id) === String(value))
      );
  }

  return (
    <Controller
      name={name}
      defaultValue={defaultValueComputed}
      control={control}
      {...props}
      render={({
        field, //{ onChange, onBlur, value, name, ref }
        fieldState: { invalid, isTouched, isDirty, error },
        formState,
      }) => {
        return (
          <>
            <ReactSelect
            options={optionsComputed}
            getOptionValue={(opt) => String(opt.id)}
            isMulti={true}
            isClearable={false}
            {...field}
            {...props}
            />
            <ErrorMessage error={error}/>
          </>

        )
      }}
    />
  );
};

export default BusinessModelSelect;